/* eslint-disable react/prop-types */

export default function ElectricityTariffTable({ eTariff, mode, setETariff }) {
  // const [isLoading, setIsLoading] = useState(false);

  const onChangeMaxDemand = (id, value) => {
    if (Number(value) < 0) {
      return;
    }
    let newData = eTariff.map((item) => {
      if (item._id === id) {
        item.maximumDemand.price = value;
      }
      return item;
    });
    setETariff(newData);
  };
  const onChangePeakOffpeak = ({ _id, name, value }) => {
    if (Number(value) < 0) {
      return;
    }
    let newData = eTariff.map((item) => {
      if (item._id === _id) {
        item.kwh[name].price = value;
      }
      return item;
    });
    setETariff(newData);
  };
  const onChangeAllKwh = ({ _id, value }) => {
    if (Number(value) < 0) {
      return;
    }
    let newData = eTariff.map((item) => {
      if (item._id === _id) {
        item.kwh.price = value;
      }
      return item;
    });
    setETariff(newData);
  };
  const onChangeRangeKwh = ({ _id, idx, value }) => {
    if (Number(value) < 0) {
      return;
    }
    let newData = eTariff.map((item) => {
      if (item._id === _id) {
        item.kwh.range[idx].price = value;
      }
      return item;
    });
    setETariff(newData);
  };

  return (
    <div className={mode ? "electricity_tariff_editable" : ""}>
      <div
        className="d-flex justify-content-between align-items-center p-3 p-md-4"
        style={{ background: "#ffdf01", color: "#0961a3" }}
      >
        <h5 className="mb-0" style={{ fontSize: "14px", fontWeight: "700" }}>
          TARIFF CATEGORY
        </h5>
        <h5 className="mb-0 me-1" style={{ fontSize: "14px", fontWeight: "700" }}>
          CURRENT RATES
        </h5>
      </div>
      {eTariff.map((item, idx) => {
        // console.log(item);
        return (
          <div key={idx} className="px-3 px-md-4" style={{ background: "#fffac2" }}>
            <h2 style={{ paddingTop: "10px", paddingBottom: "5px", fontSize: "14px", fontWeight: "700" }}>
              {item.name}
            </h2>
            {item?.maximumDemand?.varient && (
              <MaximumDemandInput
                id={item._id}
                maximumDemand={item?.maximumDemand}
                onChangeMaxDemand={onChangeMaxDemand}
                mode={mode}
              />
            )}
            {item?.kwh?.varient === "peak" && (
              <PeakOffPeakChange {...item} onChangePeakOffpeak={onChangePeakOffpeak} mode={mode} />
            )}
            {item?.kwh?.varient === "all" && <AllKWHChange {...item} onChangeAllKwh={onChangeAllKwh} mode={mode} />}
            {item?.kwh?.varient === "range" && (
              <KWHRangeChange {...item} onChangeRangeKwh={onChangeRangeKwh} mode={mode} />
            )}
          </div>
        );
      })}
    </div>
  );
}

const KWHRangeChange = ({ _id, kwh, onChangeRangeKwh, mode }) => {
  return (
    <div>
      {kwh?.range?.map((item, idx) => {
        return (
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ borderBottom: "1px solid #fae035" }}
            key={idx}
          >
            <p>
              {idx !== kwh?.range?.length - 1
                ? `For the ${idx === 0 ? "first" : "next"} ${item.end - item.start + 1} kWh [${item.start}-${
                    item.end
                  } kWh] per month`
                : `For the next kWh [${item.start} kWh onwards] per month`}
            </p>{" "}
            <div className="d-flex align-items-center">
              <input
                className="tariff_input"
                readOnly={mode}
                style={{ textAlign: "right", border: "none", padding: "5px", width: "80px" }}
                type="number"
                value={item?.price}
                onChange={(e) => onChangeRangeKwh({ _id, idx, value: e.target.value })}
              />{" "}
              <span style={{ width: "80px", display: "inline-block", marginLeft: "5px" }}>sen/kWh</span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

const MaximumDemandInput = ({ maximumDemand, onChangeMaxDemand, id, mode }) => {
  return (
    <div className="d-flex justify-content-between align-items-center" style={{ borderBottom: "1px solid #fae035" }}>
      <p>For each kW of maximum demand per month</p>{" "}
      <div className="d-flex align-items-center">
        <input
          className="tariff_input"
          readOnly={mode}
          style={{ textAlign: "right", border: "none", padding: "5px", width: "80px" }}
          type="number"
          value={maximumDemand?.price}
          onChange={(e) => onChangeMaxDemand(id, e.target.value)}
        />{" "}
        <span style={{ width: "80px", display: "inline-block", marginLeft: "5px" }}>RM/kW</span>
      </div>
    </div>
  );
};

const PeakOffPeakChange = ({ _id, kwh, onChangePeakOffpeak, mode }) => {
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center" style={{ borderBottom: "1px solid #fae035" }}>
        <p>For all kWh during the peak period</p>{" "}
        <div className="d-flex align-items-center">
          <input
            className="tariff_input"
            readOnly={mode}
            style={{ textAlign: "right", border: "none", padding: "5px", width: "80px" }}
            type="number"
            value={kwh?.peak?.price}
            onChange={(e) => onChangePeakOffpeak({ _id, name: "peak", value: e.target.value })}
          />{" "}
          <span style={{ width: "80px", display: "inline-block", marginLeft: "5px" }}>sen/kWh</span>
        </div>
      </div>
      <div className="d-flex justify-content-between align-items-center" style={{ borderBottom: "1px solid #fae035" }}>
        <p>For all kWh during the off-peak period</p>{" "}
        <div className="d-flex align-items-center">
          <input
            className="tariff_input"
            readOnly={mode}
            style={{ textAlign: "right", border: "none", padding: "5px", width: "80px" }}
            type="number"
            value={kwh?.offPeak?.price}
            onChange={(e) => onChangePeakOffpeak({ _id, name: "offPeak", value: e.target.value })}
          />{" "}
          <span style={{ width: "80px", display: "inline-block", marginLeft: "5px" }}>sen/kWh</span>
        </div>
      </div>
    </div>
  );
};

const AllKWHChange = ({ _id, kwh, onChangeAllKwh, mode }) => {
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center" style={{ borderBottom: "1px solid #fae035" }}>
        <p>For All kWh</p>{" "}
        <div className="d-flex align-items-center">
          <input
            className="tariff_input"
            readOnly={mode}
            style={{ textAlign: "right", border: "none", padding: "5px", width: "80px" }}
            type="number"
            value={kwh?.price}
            onChange={(e) => onChangeAllKwh({ _id, value: e.target.value })}
          />{" "}
          <span style={{ width: "80px", display: "inline-block", marginLeft: "5px" }}>sen/kWh</span>
        </div>
      </div>
    </div>
  );
};
